import { Button, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const StyledButton = styled(Button)(() => ({
  backgroundColor: NEW_COLORS.PRIMARY[50],
  '&:hover': {
    backgroundColor: `${NEW_COLORS.PRIMARY[500]}14`,
  },
  color: NEW_COLORS.PRIMARY[500],
  fontSize: '12px',
  fontWeight: 600,
  gap: '4px',
  padding: '8px 16px',
  minWidth: '128px',
  borderRadius: '4px',
  height: '32px',
}));
